import React from 'react';

export type ToastProps = {
  /** Toast key */
  key: string;
  /** Aria role for the toast. */
  role?: 'alert' | 'status';
  /** Toast id */
  id?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook?: string;
  /** Whether the toast should render the dismiss button. */
  dismissible?: boolean;
  /** Aria label for the dismiss button. */
  dismissLabel?: string;
  /** Callback function called whenever the user clicks the dismiss button.*/
  onDismiss?: (event?: React.MouseEvent) => void;
  children?: React.ReactNode;
};
